import { RadioSelector, RangeSelector } from './components'

import {
  CONSULTATION_TYPES,
  MAX_CONSULTATION_NUMBER,
  MAX_NEGATIVATION_NUMBER,
  REPORT_TYPES
} from './constants'

import styles from './CalculatorForm.module.scss'

export const CalculatorForm = ({
  control,
  watch,
  setValue,
  showAdditionalServices = true
}) => {
  return (
    <div>
      <>
        <label
          htmlFor="consultation_quantity"
          className={styles.calculatorForm__label}
        >
          1. Defina a quantidade de consultas que gostaria de fazer no mês
        </label>

        <RangeSelector
          control={control}
          label="consultas"
          name="consultation_quantity"
          max={MAX_CONSULTATION_NUMBER}
          value={watch('consultation_quantity')}
          onChange={(value) => setValue('consultation_quantity', value)}
        />
      </>

      <>
        <label className={styles.calculatorForm__label}>
          2. Escolha o que deseja consultar
        </label>

        <RadioSelector
          control={control}
          name="consultation_type"
          label="2. Escolha o que deseja consultar"
          options={CONSULTATION_TYPES}
        />
      </>

      <>
        <label className={styles.calculatorForm__label}>
          3. Escolha o relatório que atenderia suas necessidades
        </label>

        <div className={styles.calculatorForm__reportTypes}>
          {REPORT_TYPES.map((item, i) => (
            <RadioSelector
              control={control}
              name="report_type"
              key={`simulation-report_type--${i}`}
              options={[item]}
            />
          ))}
        </div>
      </>

      {showAdditionalServices && (
        <>
          <label
            htmlFor="negativation_quantity"
            className={styles.calculatorForm__label}
          >
            4. Defina a quantidade mensal de serviços de Negativação e
            Notificação usados pela sua empresa.
          </label>

          <RangeSelector
            min={0}
            control={control}
            label="serviços"
            name="negativation_quantity"
            max={MAX_NEGATIVATION_NUMBER}
            value={watch('negativation_quantity')}
            onChange={(value) => setValue('negativation_quantity', value)}
          />
        </>
      )}
    </div>
  )
}
